export interface WhyWeBestReasons {
    id: number;
    icon: string;
    title: string;
    description: string;
}

export const whyWeBestReasons: WhyWeBestReasons[] = [
    {
        id: 1,
        icon: '/assets/images/website/about-page/check.svg',
        title: 'Quality Check',
        description: 'We provide quality check conducted by our site engineers We provide quality check conducted by our site engineers'
    },
    {
        id: 2,
        icon: '/assets/images/website/about-page/percentage.svg',
        title: 'No Price Escalation',
        description: 'No Price Escalation once the project Start. No cost overun policy.'
    },
    {
        id: 3,
        icon: '/assets/images/website/about-page/verify.svg',
        title: 'Verified Team',
        description: 'Only verified contractor, architects are provided by us.'
    },
    {
        id: 4,
        icon: '/assets/images/website/about-page/price.svg',
        title: 'Price Transparency',
        description: 'Pricing are very transparent and cover every detail on construction.'
    },
    {
        id: 5,
        icon: '/assets/images/website/about-page/verify.svg',
        title: 'Security',
        description: 'We ensure your project is safe and secure.'
    },
    {
        id: 6,
        icon: '/assets/images/website/about-page/price.svg',
        title: 'Cost Management',
        description: 'We provide cost management tools to help you manage your project better.'
    },
    {
        id: 7,
        icon: '/assets/images/website/about-page/check.svg',
        title: 'Customer Satisfaction',
        description: 'We provide excellent customer service and always strive to improve.'
    }
]